import React from 'react';
import PropTypes from 'prop-types';
import firebase from '../../../../firebase/index';
import {TableCell, TableRow} from 'material-ui/Table';
import {withStyles} from 'material-ui/styles';
import Switch from 'material-ui/Switch';
import CellText from '../../common/cell-text/index';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui-icons/Delete';

const style = theme => ({
	row: {
		height: theme.spacing.unit * 8
	},
	emailColumn: {
		width: '85%'
	}
});

const AdminUserItem = props => {
	const {
		classes,
		item,
		isPending,
		onConfirmationChange,
		onPrivilegesChange,
		onDelete
	} = props;
	const isDisabled = firebase.auth().currentUser.uid === item.id;

	return (
		<TableRow className={classes.row}>
			<TableCell className={classes.emailColumn} padding="dense">
				<CellText>
					{item.email}
				</CellText>
			</TableCell>
			<TableCell padding="checkbox">
				<Switch
					checked={item.confirmed}
					onChange={onConfirmationChange}
					disabled={isDisabled || isPending}
				/>
			</TableCell>
			<TableCell padding="checkbox">
				<Switch
					checked={item.privileged}
					onChange={onPrivilegesChange}
					disabled={isDisabled || isPending || !item.confirmed}
				/>
			</TableCell>
			<TableCell className={classes.actionColumn} padding="checkbox">
				<IconButton
					onClick={onDelete}
					disabled={isDisabled || isPending}
				>
					<DeleteIcon/>
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

AdminUserItem.propTypes = {
	classes: PropTypes.object.isRequired,
	item: PropTypes.object.isRequired,
	isPending: PropTypes.bool.isRequired,
	onPrivilegesChange: PropTypes.func.isRequired,
	onConfirmationChange: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired
};

export default withStyles(style)(AdminUserItem);



// WEBPACK FOOTER //
// ./src/client/components/admin/users/item/item.jsx